import { render, staticRenderFns } from "./Universes.html?vue&type=template&id=187d6653&scoped=true&"
import script from "./Universes.vue?vue&type=script&lang=js&"
export * from "./Universes.vue?vue&type=script&lang=js&"
import style0 from "./Universes.scss?vue&type=style&index=0&id=187d6653&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187d6653",
  null
  
)

export default component.exports